import { useCallback, useState } from "react";

// some helpful boilerplate
/*
  const { page, pageSize, setPage } = usePagination();
  const setPageRef = useRef(setPage);
  setPageRef.current = setPage;
  useEffect(() => setPageRef.current(1), [serialized]);
*/

type Pagination = { page: number; pageSize: number };

export function usePagination(initial?: Partial<Pagination>) {
  const [page, setPage] = useState(initial?.page || 1);
  const [pageSize, setPageSize] = useState(initial?.pageSize || 20);
  const setPagination = useCallback(
    (paging: Partial<Pagination>) => {
      const pagination = { page, pageSize, ...paging };
      setPage(pagination.page);
      setPageSize(pagination.pageSize);
    },
    [page, pageSize]
  );
  return { page, pageSize, setPage, setPageSize, setPagination };
}
